module.exports = __webpack_public_path__ + "tui-logo.png?70f4cb7a0b21d86d528dce6d09d9f8a7";